import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const consumerDirectoryKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    id: <U extends QueryKeyParam>(id: U) =>
      createQueryKey({
        all: [...keys, id] as const,
      }),
    export: [...keys, 'export'] as const,
    lists: [...keys, 'lists'] as const,
  });

export { consumerDirectoryKeys };
